// Vue
import { Module } from "#/common/interfaces/Module";
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class EditWrapper extends Vue {
  @Prop({ default: () => ({}) })
  public module!: Partial<Module>;

  @Prop({ default: 0 })
  public pageId!: number;

  get translationStatusClass() {
    let status = <string>this.module["translation_status"]["status"];
    return status.toLocaleLowerCase().replace(/_/g, "-");
  }

  get showTranslationStatusButton() {
    return (
      <string>this.module["translation_status"]["status"] !==
      "TRANSLATION_STATUS_NO_TRANSLATIONS"
    );
  }

  public handleUpdateTranslationStatus() {
    this.sendToParent({
      type: "Cms.Widget.UpdateTranslationStatus",
      pageId: this.pageId,
      widgetId: this.module["id"],
    });
  }

  public handleAddBelow() {
    this.sendToParent({
      type: "Cms.Widget.Add",
      after: this.module["id"],
      pageId: this.pageId,
    });

    return true;
  }

  public handleMoveUp() {
    this.sendToParent({
      type: "Cms.Widget.Move.Up",
      pageId: this.pageId,
      widgetId: this.module["id"],
    });

    return true;
  }

  public handleMoveDown() {
    this.sendToParent({
      type: "Cms.Widget.Move.Down",
      pageId: this.pageId,
      widgetId: this.module["id"],
    });

    return true;
  }

  public handleDelete() {
    this.sendToParent({
      type: "Cms.Widget.Delete",
      widgetId: this.module["id"],
      pageId: this.pageId,
    });
  }

  public handleSelectModule() {
    if (this.$store.page.isAllowedToEditModule) {
      this.sendToParent({
        type: "Cms.Widget.Clicked",
        widgetId: this.module["id"],
      });
    }
  }

  private sendToParent(message) {
    window.parent.window.postMessage(
      JSON.stringify(message),
      window.CMS_DOMAIN
    );
  }

  get isLimitedVisibility(): boolean {
    return this.module["is_limited_visibility"];
  }

  get isHidden(): boolean {
    return (
      this.module["content"]!["common_options"]["hide"] === "1" ||
      this.module["content"]!["common_options"]["hide"] === true
    );
  }

  get copyButtonTheme() {
    return this.$store.modules.modulesToCopy.includes(this.module.id!)
      ? "error"
      : "secondary";
  }

  toggleModuleToCopy() {
    this.$store.modules.toggleModuleToCopy(this.module.id!);
    const widgetIds = this.$store.modules.modulesToCopy;
    this.$nextTick(() => {
      this.sendToParent({
        type: "Cms.Widget.SetWidgetsToCopy",
        widgetIds,
      });
    });
  }
}
